import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useVerifyEmailMutation } from '@src/features/auth/redux';
import { routesConfig } from '@src/core/routes';
import { IVerifyEmailForm } from '@src/features/auth/pages/verify-email-page/types';
import { normalizeEmail } from '@src/features/auth/utils/normalize-email';
import { trackError, toTrackedError } from '@src/core/sentry';

export const useVerifyEmailForm = () => {
  const navigate = useNavigate();
  const [verifyEmail, { isLoading }] = useVerifyEmailMutation();
  const form = useForm<IVerifyEmailForm>();

  const onSubmit = async (data: IVerifyEmailForm) => {
    verifyEmail({ ...data, email: normalizeEmail(data.email) }).unwrap()
      .then(() => {
        navigate(routesConfig.verifySuccess, { replace: true });
      })
      .catch((err: unknown) => {
        trackError(toTrackedError(err), { code: 'FE_0022', extra: { flow: 'verifyEmail' } });
      });
  };

  return {
    ...form,
    onSubmit: form.handleSubmit(onSubmit),
    isLoading,
  };
};

